module.exports = __webpack_public_path__ + "media/welcome-message/meetup@1x-5d26d760.png";